import { injectable } from "tsyringe";
import Optional from "optional-js";

import { autoBind } from "src/shared/decorators/autobind";
import { CrmRequest } from "src/containers/requests/models/crm-request.model";
import { RequestStatus } from "src/containers/requests/types/request-status";

@injectable()
export class CrmRequestsService {
    @autoBind
    isEmpty(requests: Optional<CrmRequest[]>): boolean {
        return requests.orElse([]).length === 0;
    }

    @autoBind
    getLastByStatus(
        requests: Optional<CrmRequest[]>,
        status: RequestStatus
    ): Optional<CrmRequest> {
        if (!requests.isPresent()) {
            return Optional.empty();
        }
        return Optional.ofNullable(
            requests.get().find((req) => req.status === status)
        );
    }
}
